import React from 'react';
import { connect } from 'react-redux';
import ReactTimeout from 'react-timeout';
import BundleSelector from '../components/molecules/BundleSelector';
import { setBundle, resetOptions, resetPayment, resetOrder, resetCheckout, resetUpload, resetSubmit, resetPrivacy, resetSepa, resetFinish, setTeacherOverlay, setPayeverChangeOverlay } from '../actions/status';
import { showNextButton } from '../actions/next';
import { resetPayever } from '../actions/payever';
import { showTextOverlay } from '../actions/textoverlay';
var AppConfig = require('../config.json');

const projectDescription = desc => {
  return {__html:desc.split("\r").join("<br>")};
}

class BundlesView extends React.Component {

    constructor(props) {
      super(props);
      this.selectBundle = this.selectBundle.bind(this);
      this.isSelected = this.isSelected.bind(this);
      this.showInfoTeacherPdf = this.showInfoTeacherPdf.bind(this);
      this.showChangePayeverPdf = this.showChangePayeverPdf.bind(this);
      this.state = {
        bundleId: 0,
        isset: false
      };
    }

    componentDidMount() {
      // if(this.props.pathname==="/"+AppConfig.links.bundles.url && (this.props.linkTo===AppConfig.links.bundles.url || this.props.linkTo==="")) {
        this.props.dispatch(showNextButton({link: AppConfig.links.options.url, label: 'Weiter', watch: 'bundle', submitDelay:200}));
      // }
      if(this.state.bundleId!==this.props.bundle.id) {
        
        this.setState({
          bundleId: this.props.bundle.id,
          isset: true
        });
        
      }
      if(!this.props.teacherpdf.shown && this.props.project.teachers) {
        this.props.setTimeout(this.showInfoTeacherPdf, 1000);
      }
      // if(!this.props.payeverchangepdf.shown && !this.props.project.teachers) {
      //   this.props.setTimeout(this.showChangePayeverPdf, 1000);
      // }
    }

    shouldComponentUpdate(nextProps, nextState) {
      return this.props.pathname===nextProps.pathname;
    }

    componentDidUpdate(prevProps, prevState) {
      // if(prevState.isset===false) {
      //   return;
      // }
      if(this.state.bundleId!==prevProps.bundle.id) {
        if(prevProps.bundle.id!==0) {
          this.props.dispatch(resetOptions());
          this.props.dispatch(resetPayment());
          this.props.dispatch(resetOrder());
          this.props.dispatch(resetUpload());
          this.props.dispatch(resetCheckout());
          this.props.dispatch(resetPrivacy());
          this.props.dispatch(resetSepa());
          this.props.dispatch(resetFinish());
          this.props.dispatch(resetPayever());
          
        }
        // this.setState({
        //   bundleId: nextProps.bundle.id,
        //   isset: true
        // });
      }
      this.props.dispatch(resetSubmit());
    }

    showInfoTeacherPdf() {
      this.props.dispatch(setTeacherOverlay());
      this.props.dispatch(showTextOverlay({text:AppConfig.teacher.overlay.text,headline:AppConfig.teacher.overlay.headline,download:AppConfig.teacher.overlay.download,downloadStr:"» Laden Sie hier die Vorlage als PDF herunter."}));
      
    }
    showChangePayeverPdf() {
      this.props.dispatch(setPayeverChangeOverlay());
      this.props.dispatch(showTextOverlay({text:AppConfig.payeverchange.overlay.text,headline:AppConfig.payeverchange.overlay.headline,download:AppConfig.payeverchange.overlay.download,downloadStr:"» Lesen Sie hier die Hinweise im PDF."}));
      
    }

    selectBundle(bundle) {
      
      this.setState({
        bundleId: bundle.id,
        isset: true
      }, function() {
        this.props.dispatch(setBundle({id: bundle.id}));
      });
    }

    isSelected(bundle) {
      if(!this.props.bundle.isset) {
        return false;
      }
      if(bundle.id===this.props.bundle.id) {
        return true;
      }
      return false;
    }

    render () {
        return (
          <div className="contentview bundles">
            <div className="intro">
              <h2>{this.props.project.name}</h2>
              <p dangerouslySetInnerHTML={projectDescription(this.props.project.data.description)} />
              
            </div>
            <div id="bundleselection" className={`items_${this.props.project.data.bundles.length} rows_${(Math.ceil(this.props.project.data.bundles.length/3))}`}>
              {
                this.props.project.data.bundles.map((bundle, n) => <BundleSelector isSingleChoice={this.props.project.data.bundles.length===1?true:false} key={`bundle_${n}`} bundle={bundle} selected={this.isSelected(bundle)} onClick={this.selectBundle} />)
              }
            </div>
          </div>
        );
    }

}



const mapStateToProps = (state) => {
  return {
    pathname: state.routing.location.pathname,
    project: state.status.project,
    teacherpdf: state.status.teacherpdf,
    payeverchangepdf: state.status.payeverchangepdf,
    linkTo: state.content.link,
    bundle: state.status.bundle
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch: dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReactTimeout(BundlesView))



// WEBPACK FOOTER //
// ./src/views/BundlesView.js